export const no_policies = {
  refund: {
    title: "Refusjonsretningslinjer",
    backToCheckout: "Tilbake til kassen",
    backToHome: "Tilbake til hjemmesiden",
    setupFeeNotice: "Oppstartsgebyret på €500 er ikke refunderbart når utviklingen har startet.",
    subscriptionNotice: "Abonnementsbetalinger er ikke refunderbare for fakturerte perioder.",
    exceptionalCircumstances: "Eksepsjonelle Omstendigheter",
    exceptionalText: "Dathent beholder skjønnsmessig myndighet i eksepsjonelle omstendigheter.",
    processTitle: "Refusjonsprosess",
    processText: "Hvis du mener du har en gyldig sak for et refusjonsunntak, vennligst kontakt oss på:",
    earlyTerminationTitle: "Tidlig Oppsigelse",
    earlyTerminationText: "For informasjon om tidlig oppsigelse av Infrastructure Commitment-modellen, vennligst se",
    termsLink: "Tjenestevilkår",
    lastUpdated: "Sist oppdatert: Februar 2026"
  },
  privacy: {
    title: "Personvernregler",
    backToCheckout: "Tilbake til kassen",
    backToHome: "Tilbake til hjemmesiden",
    dataControllerTitle: "Databehandler",
    companyName: "DATHENT SAX S.L.",
    nif: "NIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spania",
    dataCollectedTitle: "Innsamlede Data",
    dataCollectedText: "Vi samler inn og behandler følgende kategorier av personopplysninger:",
    contactDetails: "Kontaktinformasjon (navn, e-post, telefon)",
    projectInfo: "Prosjektinformasjon",
    commHistory: "Kommunikasjonshistorikk",
    purposeTitle: "Formål",
    purposeText: "Data behandles strengt for:",
    serviceDelivery: "Tjenestelevering",
    clientComm: "Kundekommunikasjon",
    paymentProcessing: "Betalingsbehandling",
    operationalImprovement: "Operasjonell forbedring",
    paymentSecurityTitle: "Betalingssikkerhet",
    paymentSecurityText1: "Betalinger behandles gjennom",
    paymentSecurityText2: "Dathent lagrer ikke betalingskortinformasjon.",
    dataRightsTitle: "Datarettigheter",
    dataRightsText: "I samsvar med GDPR kan klienter be om:",
    accessRight: "Tilgang til sine personopplysninger",
    rectificationRight: "Retting av unøyaktige data",
    erasureRight: "Sletting av personopplysninger",
    restrictionRight: "Begrensning av behandling",
    requestsLabel: "Forespørsler:",
    dataRetentionTitle: "Datalagring",
    dataRetentionText: "Personopplysninger oppbevares kun så lenge det er nødvendig for formålene nevnt ovenfor, eller som påkrevd av gjeldende lov.",
    thirdPartySharingTitle: "Deling av Data med Tredjeparter",
    thirdPartySharingText: "Vi selger eller deler ikke personopplysninger med tredjeparter, bortsett fra når det er nødvendig for tjenestelevering (f.eks. betalingsbehandling via Stripe).",
    contactTitle: "Kontakt",
    contactText: "For personvernrelaterte henvendelser, vennligst kontakt:",
    lastUpdated: "Sist oppdatert: Februar 2026"
  },
  terms: {
    title: "Tjenestevilkår",
    backToCheckout: "Tilbake til kassen",
    backToHome: "Tilbake til hjemmesiden",
    companyTitle: "1. Selskap",
    companyText: "Denne nettsiden og relaterte tjenester drives av:",
    companyName: "DATHENT SAX S.L.",
    cif: "CIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spania",
    companyNote: "Tjenester levert under spansk lov og registrert i handelsregisteret i Alicante.",
    companyDesc: "Dathent tilbyr strukturerte nettstedsinfrastruktur- og langsiktige tekniske støtteløsninger for bedrifter.",
    serviceModelsTitle: "2. Tjenestemodeller",
    serviceModelsText: "Dathent tilbyr to kommersielle modeller:",
    fullDevTitle: "A. Fullstendig Utviklingsmodell",
    fullDevPrice: "Engangsbeløp: €1500",
    fullDevNoSubscription: "Ingen abonnementsforpliktelse.",
    fullDevDesc: "Denne modellen inkluderer fullstendig nettstedlevering uten langsiktig støtteforpliktelse.",
    infraCommitTitle: "B. Infrastructure Commitment-modell",
    infraSetup: "Første oppsett: €500",
    infraSupport: "Løpende infrastrukturstøtte: €50 per måned",
    infraMinimum: "Minimumsforpliktelse: 12 måneder",
    infraDesc: "Denne modellen gir en redusert utviklingspris i bytte mot en strukturert langsiktig støtteavtale.",
    infraNote: "Standard støttesats er €150 per måned. €50-satsen er et kontraktsmessig insentiv knyttet til 12-måneders forpliktelsen.",
    commercialStructureTitle: "3. Kommersiell Struktur",
    commercialPoint1: "Den reduserte utviklingsavgiften (€500) er ikke et frittstående produkt.",
    commercialPoint2: "Det er en del av en strukturert infrastrukturavtale.",
    commercialPoint3: "Den økonomiske verdien av utviklingen forblir €1500.",
    commercialPoint4: "Den reduserte inngangsprisen gis i betraktning av 12-måneders forpliktelsen.",
    earlyTerminationTitle: "4. Tidlig Oppsigelse",
    earlyTerminationText: "Hvis klienten sier opp støtteavtalen før fullføring av 12 måneder, forfaller gjenværende økonomisk verdi.",
    calculationTitle: "Beregning:",
    fullDevValue: "Fullstendig utviklingsverdi: €1500",
    paidAtSetup: "Beløp betalt ved oppsett: €500",
    outstandingBalance: "Utestående saldo: €1000",
    settlementNote: "Ved oppgjør av denne saldoen avsluttes støtteavtalen og ingen ytterligere månedlige kostnader påløper.",
    deliveryFrameworkTitle: "5. Leveringsramme",
    deliveryText: "Utvikling starter etter betalingsbekreftelse og mottak av nødvendige materialer.",
    deliveryTime: "Typisk leveringstid: fra 1 uke.",
    acceleratedDelivery: "Akselerert levering kan være mulig avhengig av prosjektomfang.",
    timelinesDepend: "Tidsfrister avhenger av kundens responsivitet og prosjektkompleksitet.",
    intellectualPropertyTitle: "6. Immaterielle Rettigheter",
    ipText: "Fullt eierskap til det utviklede nettstedet overføres ved fullføring av de økonomiske forpliktelsene under enten:",
    ip12Months: "12-måneders infrastrukturforpliktelse",
    ipOr: "ELLER",
    ipFullPayment: "Fullstendig betaling av totalverdi på €1500",
    limitationTitle: "7. Ansvarsbegrensning",
    limitationText: "DATHENT SAX S.L. er ikke ansvarlig for:",
    thirdPartyInterruptions: "Tredjeparts tjenestebrudd",
    hostingFailures: "Hostingleverandørfeil",
    clientDelays: "Forsinkelser forårsaket av ufullstendig kundeinformasjon",
    limitationNote: "Ansvar er begrenset til verdien av den kjøpte tjenesten.",
    governingLawTitle: "8. Gjeldende Lov",
    governingLawText: "Disse vilkårene er underlagt lovene i Spania.",
    lastUpdated: "Sist oppdatert: Februar 2026"
  },
  subscriptionPolicy: {
    title: "Abonnementsavtale",
    backToCheckout: "Tilbake til kassen",
    backToHome: "Tilbake til hjemmesiden",
    infraSupportTitle: "1. Infrastrukturstøtte",
    infraSupportText: "Infrastrukturstøttetjenesten sikrer:",
    techStability: "Teknisk stabilitet",
    continuousMaintenance: "Kontinuerlig vedlikehold",
    minorAdjustments: "Mindre funksjonelle justeringer",
    monitoring: "Overvåking og ytelseskontroll",
    standardRate: "Standardsats: €150 per måned.",
    discountedRateTitle: "2. Rabattert Forpliktelsessats",
    discountedRateText: "€50/måned-satsen gis utelukkende under Infrastructure Commitment-modellen.",
    minimumTerm: "Minimumsperiode: 12 måneder.",
    discountedRateNote: "Den rabatterte satsen gjenspeiler en langsiktig samarbeidsstruktur.",
    billingStructureTitle: "3. Faktureringsstruktur",
    billing30Days: "Fakturering starter 30 dager etter første oppsettsbetalingen.",
    billingStripe: "Betalinger behandles sikkert via Stripe.",
    earlyExitTitle: "4. Tidlig Uttredelsesklausul",
    earlyExitText: "Hvis oppsagt før 12 måneder, forfaller gjenværende økonomisk verdi på €1000.",
    earlyExitNote: "Etter oppgjør gjelder ingen ytterligere abonnementsbetalinger.",
    postCommitmentTitle: "5. Fase Etter Forpliktelse",
    postCommitmentText: "Etter 12 måneder fortsetter avtalen måned for måned.",
    postCommitmentNote: "Klienten kan si opp når som helst uten straff.",
    lastUpdated: "Sist oppdatert: Februar 2026"
  },
  cookies: {
    title: "Retningslinjer for Informasjonskapsler",
    backToCheckout: "Tilbake til kassen",
    backToHome: "Tilbake til hjemmesiden",
    whatAreCookiesTitle: "Hva er Informasjonskapsler",
    whatAreCookiesText: "Informasjonskapsler er små tekstfiler som lagres på enheten din når du besøker et nettsted. De hjelper nettstedet med å huske informasjon om besøket ditt.",
    essentialCookiesTitle: "Nødvendige Informasjonskapsler",
    essentialCookiesText: "Dette nettstedet bruker nødvendige informasjonskapsler som kreves for drift.",
    essentialCookiesNote: "Disse informasjonskapslene er nødvendige for at nettstedet skal fungere riktig og kan ikke deaktiveres.",
    analyticsCookiesTitle: "Analytiske Informasjonskapsler",
    analyticsCookiesText: "Analytiske informasjonskapsler kan brukes til å forbedre ytelsen og forstå hvordan besøkende samhandler med nettstedet.",
    analyticsCookiesNote: "Disse informasjonskapslene hjelper oss med å analysere nettstedstrafikk og optimalisere brukeropplevelsen.",
    managingCookiesTitle: "Administrere Informasjonskapsler",
    managingCookiesText: "Brukere kan deaktivere ikke-nødvendige informasjonskapsler via nettleserinnstillinger.",
    chromeSettings: "Chrome: Innstillinger → Personvern og sikkerhet → Informasjonskapsler",
    firefoxSettings: "Firefox: Innstillinger → Personvern & Sikkerhet → Informasjonskapsler",
    safariSettings: "Safari: Innstillinger → Personvern → Informasjonskapsler",
    disablingNote: "Merk: Deaktivering av nødvendige informasjonskapsler kan påvirke nettstedets funksjonalitet.",
    thirdPartyCookiesTitle: "Tredjeparts Informasjonskapsler",
    thirdPartyCookiesText: "Vi kan bruke tredjepartstjenester som setter sine egne informasjonskapsler:",
    stripeLabel: "Stripe – for betalingsbehandling",
    analyticsLabel: "Analyseverktøy – for ytelsesovervåking",
    updatesTitle: "Oppdateringer av Denne Retningslinjen",
    updatesText: "Vi kan oppdatere denne retningslinjen for informasjonskapsler fra tid til annen. Eventuelle endringer vil bli publisert på denne siden med en oppdatert revisjonsdato.",
    contactTitle: "Kontakt",
    contactText: "For spørsmål om vår bruk av informasjonskapsler, vennligst kontakt:",
    lastUpdated: "Sist oppdatert: Februar 2026"
  }
};
